"use client";

import { useRef } from "react";
import { motion } from "framer-motion";
import { useInView } from "@/hooks/useInView";

export default function BoardingSchoolIntro({ cms }: { cms?: Record<string, string> }) {
  const headingRef = useRef<HTMLDivElement>(null);
  const showHeading = useInView(headingRef, { margin: "0px" });

  return (
    <section className="bg-white py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <motion.div
          ref={headingRef}
          initial={{ opacity: 0, y: 60 }}
          animate={showHeading ? { opacity: 1, y: 0 } : { opacity: 0, y: 60 }}
          transition={{ type: "spring", stiffness: 120, damping: 20, duration: 0.6 }}
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-4 text-school-navy text-left">
            {cms?.heading /* || "Ashton John\u2019s Private School" */}
          </h1>
          <p className="text-2xl sm:text-3xl md:text-4xl font-light text-school-navy mb-6 text-left">
            {cms?.subheading ||
              /* "We uphold a strong sense of discipline and character among our boarding students." */
              undefined}
          </p>
        </motion.div>
        <div className="text-lg sm:text-xl md:text-2xl text-school-navy space-y-6 mb-8 font-light leading-relaxed">
          <p>
            {cms?.para1 ||
              /* "Our boarding facility serves as a nurturing environment where students can learn, grow, and nourish in safety and support. We view discipline as a fundamental aspect of the boarding experience, working closely with students to ensure they comprehend and adhere to our expectations and regulations." */
              undefined}
          </p>
          <p>
            {cms?.para2 ||
              /* "Our boarding house is right next to the school, with our soccer field linking the two. Students are never far from their classrooms, their teammates, or each other." */
              undefined}
          </p>
          <p>
            {cms?.para3 ||
              /* "We are based in Klerksdorp, about 180 km from Johannesburg and 230 km from Pretoria, so getting here is straightforward for families in Gauteng and the surrounding provinces. We have students from all over South Africa and also welcome international students from Zimbabwe, Botswana, Namibia and beyond." */
              undefined}
          </p>
        </div>
        <a
          href="/contact-us"
          className="bg-school-gold hover:bg-school-gold-dark text-black font-bold py-4 px-8 rounded text-lg transition-colors text-center inline-block"
        >
          {cms?.btn_text /* || "CONTACT US" */}
        </a>
      </div>
    </section>
  );
}
